import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import OrderProgress from './orderProgress';

const RecentOrders = ({ orders }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!orders || orders.length === 0) {
    return null;
  }

  return (
    <div>
      <p className="font-primaryMedium text-primary text-base text-center mt-5 mb-8">
        {t('order.recentOrders')}
      </p>
      {orders.map((order) => (
        <div key={order.id} className="mb-3">
          <OrderProgress
            isCompleted={order.isCompleted}
            isInProgress={order.isInProgress}
            orderNumber={order.externalNumber || order.number}
            onClick={() => {
              navigate(`/order/${order.id}`);
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default RecentOrders;
